module.exports = __webpack_public_path__ + "img/VillaLoreto_Restl.a2f00c0e.jpg";